export enum EventScreenshotPreviewMode {
  List = 'list',
  Grid = 'grid',
}
